// extracted by mini-css-extract-plugin
module.exports = {"componentStyle":"LotteryDetailDescription_componentStyle__t08pL","itemHr":"LotteryDetailDescription_itemHr__dNst_","hidden":"LotteryDetailDescription_hidden__WqjPl"};